export const blockIconsHomeModeFanOff = (
	<span className='material-symbols-outlined'>mode_fan_off</span>
);
